<div class="modal-container">
<div class="modal-body">
  <div class="modal-content-wrap">
    <div class="success-img-wrap">
      <img *ngIf="accessData ==='success'" class="m-title" src="../../../../assets/img/icons/success_tick.png" class="img-fluid" />
      <img *ngIf="accessData === 'error'" class="m-title" src="../../../../assets/img/icons/failed_tick.png" class="img-fluid" />
    </div>
    <h3 class="m-title">{{initialState?.data?.message}}</h3>
    <p class="m-content0">{{initialState?.data?.subMessage}}</p>
    <p class="m-content0">{{initialState?.data?.subSubMessage}}</p>
      <div class="modal-button-wrap">
        <button type="button" class="btn btn-orange" (click)="onClose()" aria-label="Close">Ok
        </button>
      </div>
  </div>
</div>




